/**
 * CSS object-fit Polyfill for IE
 */

import { objectFitImages } from './../../vendor/ofi';

document.addEventListener( 'DOMContentLoaded', function() {
	'use strict';

	if ( 'undefined' !== objectFitImages ) {
		objectFitImages();
	}

} );
